import React, { useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import Connector from '../../Components/Connector';
import Page from '../../Components/Page';

import { useAutoLoginUserMutation } from '../../redux/api/auth';
import useWebSocket from '../../Utils/useWebsocket.js';
import { setAccessToken, setUser } from '../../redux/reducers/authSlice';
import { setConnector, updateOCPPChargingPoint } from '../../redux/reducers/chargingPointSlice';
import { selectConnector } from '../../redux/selectors/chargingPoint';
import { selectAuthData } from '../../redux/selectors/auth.js';

import './style.scss';
import { useGetSessionBySecureIdQuery } from '../../redux/api/sessions.js';

const UserSession = () => {
  const { sessionId:securedSessionId } = useParams();
  const { isLoading, user: { id: userId = '' } = {} } = useSelector(selectAuthData);
  const dispatch = useDispatch();
  const connector = useSelector(selectConnector);



  const hasAutoLoggedIn = useRef(false);
  const [
    autoLoginUser,
    { data: tokensData, isSuccess, error: { data: { message: errorMessage = '' } = {} } = {} }
  ] = useAutoLoginUserMutation();

  const {
    data: sessionData,
    error: sessionError,
    isLoading: isSessionLoading,
    isSuccess: isSessionSuccess
  } = useGetSessionBySecureIdQuery(
    { 
      secureId: securedSessionId
    },
    {
      skip: !isSuccess
    }
  );

    const channels = useMemo(() => ([
      {
        nameSpace: 'sessions',
        data: securedSessionId,
        responseEvent: 'sessionUpdates'
      }
    ]), [securedSessionId]);

    const rooms = useMemo(() => (
      sessionData?.chargePoint?.id ? [sessionData.chargePoint.id] : []
    ), [sessionData?.chargePoint?.id]);

    useWebSocket(
      channels,
      updateOCPPChargingPoint,
      rooms
    );

  useEffect(() => {
    if (isSessionSuccess) {
      const connectorData = {
        ...sessionData.chargePointConnector,
        chargingPoint: { ...sessionData.chargePoint },
        user: sessionData.user,
        transactionId: sessionData.id,
        sessions: sessionData
      };
      dispatch(setConnector({ connector: connectorData }));

    }
  }, [isSessionSuccess]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (securedSessionId && !hasAutoLoggedIn.current) {
        autoLoginUser({ sessionId: securedSessionId, userId });
        hasAutoLoggedIn.current = true;
      }
    }, 400);
    return () => clearTimeout(timer);
  }, [securedSessionId, userId]);

  useEffect(() => {
    if (isSuccess) {
      const { token, refreshToken } = tokensData.tokens;
      dispatch(setAccessToken({ token, refreshToken }));
    }
  }, [isSuccess]);

  useEffect(() => {
    if (connector?.status === 'Finishing') {
      setTimeout(() => {
        autoLoginUser({ sessionId: securedSessionId, userId });
      }, 1000);
    }
  }, [connector?.status]);

  return (
    <Page title='User Session' contentClass='page__content--center' noSidebar>
      {connector && <Connector connector={connector} fromCharge isSession={true} />}
      {errorMessage && <div className='payment-page__error'>{errorMessage}</div>}
    </Page>
  );
};

export default UserSession;
